import { ISVGSettings } from './svgChart.types'
import { IEquipment } from '../../../Equipment/equipment.types.ts'
import { TParameterKey } from '../../../Parameters/parameters.types.ts'

const extractDevicesAndParameters = (svg: ISVGSettings) => {
  const devicesSet = new Set<IEquipment['id']>()
  const parametersSet = new Set<TParameterKey>()

  for (const settingKey of settingsKeys) {
    const settingsRows = svg[settingKey]

    for (const row of settingsRows) {
      devicesSet.add(row.device_id)
      parametersSet.add(row.parameter_id)
    }
  }

  return {
    devices: Array.from(devicesSet),
    parameters: Array.from(parametersSet),
  }
}

const settingsKeys = ['color', 'movements', 'rotations', 'visibility', 'text'] as const

const svgUtils = { extractDevicesAndParameters }
export default svgUtils
